// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__XHA2R","title":"styles_title__rIMm6"};